var _rect, _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkWood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 115,
    viewBox: "0 0 1440 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 114,
    transform: "translate(0 0.1875)",
    fill: "#F1D5C9",
    fillOpacity: 0.57
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2701_497)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2701_497)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 180.188V0.1875H70V180.188H45ZM67 76.1875H57.5H48C48 71.6311 51.8161 64.1875 57.5 64.1875C63.1839 64.1875 67 71.6311 67 76.1875ZM48.0001 78.1875L57.5001 110.188L67.0001 78.1875H48.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 180.188,
    x2: 111.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.5,
    y1: 180.188,
    x2: 155.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202 180.188V0.1875H227V180.188H202ZM224 76.1875H214.5H205C205 71.6311 208.816 64.1875 214.5 64.1875C220.184 64.1875 224 71.6311 224 76.1875ZM205 78.1875L214.5 110.188L224 78.1875H205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.5,
    y1: 180.188,
    x2: 268.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.5,
    y1: 180.188,
    x2: 312.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359 180.188V0.1875H384V180.188H359ZM381 76.1875H371.5H362C362 71.6311 365.816 64.1875 371.5 64.1875C377.184 64.1875 381 71.6311 381 76.1875ZM362 78.1875L371.5 110.188L381 78.1875H362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.5,
    y1: 180.188,
    x2: 425.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469.5,
    y1: 180.188,
    x2: 469.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516 180.188V0.1875H541V180.188H516ZM538 76.1875H528.5H519C519 71.6311 522.816 64.1875 528.5 64.1875C534.184 64.1875 538 71.6311 538 76.1875ZM519 78.1875L528.5 110.188L538 78.1875H519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.5,
    y1: 180.188,
    x2: 582.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 626.5,
    y1: 180.188,
    x2: 626.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673 180.188V0.1875H698V180.188H673ZM695 76.1875H685.5H676C676 71.6311 679.816 64.1875 685.5 64.1875C691.184 64.1875 695 71.6311 695 76.1875ZM676 78.1875L685.5 110.188L695 78.1875H676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M742 180.188V0.1875H767V180.188H742ZM764 76.1875H754.5H745C745 71.6311 748.816 64.1875 754.5 64.1875C760.184 64.1875 764 71.6311 764 76.1875ZM745 78.1875L754.5 110.188L764 78.1875H745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 808.5,
    y1: 180.188,
    x2: 808.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 852.5,
    y1: 180.188,
    x2: 852.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899 180.188V0.1875H924V180.188H899ZM921 76.1875H911.5H902C902 71.6311 905.816 64.1875 911.5 64.1875C917.184 64.1875 921 71.6311 921 76.1875ZM902 78.1875L911.5 110.188L921 78.1875H902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 965.5,
    y1: 180.188,
    x2: 965.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1009.5,
    y1: 180.188,
    x2: 1009.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1056 180.188V0.1875H1081V180.188H1056ZM1078 76.1875H1068.5H1059C1059 71.6311 1062.82 64.1875 1068.5 64.1875C1074.18 64.1875 1078 71.6311 1078 76.1875ZM1059 78.1875L1068.5 110.188L1078 78.1875H1059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1122.5,
    y1: 180.188,
    x2: 1122.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1166.5,
    y1: 180.188,
    x2: 1166.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1213 180.188V0.1875H1238V180.188H1213ZM1235 76.1875H1225.5H1216C1216 71.6311 1219.82 64.1875 1225.5 64.1875C1231.18 64.1875 1235 71.6311 1235 76.1875ZM1216 78.1875L1225.5 110.188L1235 78.1875H1216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1279.5,
    y1: 180.188,
    x2: 1279.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1323.5,
    y1: 180.188,
    x2: 1323.5,
    y2: 0.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1370 180.188V0.1875H1395V180.188H1370ZM1392 76.1875H1382.5H1373C1373 71.6311 1376.82 64.1875 1382.5 64.1875C1388.18 64.1875 1392 71.6311 1392 76.1875ZM1373 78.1875L1382.5 110.188L1392 78.1875H1373Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.1875,
    width: 1436,
    height: 24,
    stroke: "white",
    strokeWidth: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432.51 72.1875V41.642H438.968V66.8629H452.064V72.1875H432.51ZM483.221 56.9148C483.221 60.2457 482.589 63.0795 481.326 65.4162C480.074 67.7528 478.363 69.5376 476.196 70.7706C474.038 71.9936 471.612 72.6051 468.917 72.6051C466.203 72.6051 463.767 71.9886 461.609 70.7557C459.451 69.5227 457.746 67.7379 456.493 65.4013C455.24 63.0646 454.614 60.2358 454.614 56.9148C454.614 53.5838 455.24 50.75 456.493 48.4134C457.746 46.0767 459.451 44.2969 461.609 43.0739C463.767 41.8409 466.203 41.2244 468.917 41.2244C471.612 41.2244 474.038 41.8409 476.196 43.0739C478.363 44.2969 480.074 46.0767 481.326 48.4134C482.589 50.75 483.221 53.5838 483.221 56.9148ZM476.673 56.9148C476.673 54.7571 476.35 52.9375 475.703 51.456C475.067 49.9744 474.167 48.8509 473.004 48.0852C471.841 47.3196 470.478 46.9368 468.917 46.9368C467.356 46.9368 465.994 47.3196 464.831 48.0852C463.667 48.8509 462.762 49.9744 462.116 51.456C461.48 52.9375 461.162 54.7571 461.162 56.9148C461.162 59.0724 461.48 60.892 462.116 62.3736C462.762 63.8551 463.667 64.9787 464.831 65.7443C465.994 66.5099 467.356 66.8928 468.917 66.8928C470.478 66.8928 471.841 66.5099 473.004 65.7443C474.167 64.9787 475.067 63.8551 475.703 62.3736C476.35 60.892 476.673 59.0724 476.673 56.9148ZM514.955 52.3359H508.423C508.303 51.4908 508.06 50.7401 507.692 50.0838C507.324 49.4176 506.852 48.8509 506.275 48.3835C505.698 47.9162 505.032 47.5582 504.276 47.3097C503.531 47.0611 502.72 46.9368 501.845 46.9368C500.264 46.9368 498.887 47.3295 497.714 48.1151C496.541 48.8906 495.631 50.0241 494.985 51.5156C494.338 52.9972 494.015 54.7969 494.015 56.9148C494.015 59.0923 494.338 60.9219 494.985 62.4034C495.641 63.8849 496.556 65.0036 497.729 65.7592C498.902 66.5149 500.259 66.8928 501.801 66.8928C502.666 66.8928 503.466 66.7784 504.202 66.5497C504.948 66.321 505.609 65.9879 506.186 65.5504C506.762 65.103 507.24 64.5611 507.617 63.9247C508.005 63.2884 508.274 62.5625 508.423 61.7472L514.955 61.777C514.786 63.179 514.364 64.5312 513.688 65.8338C513.021 67.1264 512.122 68.2848 510.988 69.3089C509.865 70.3232 508.522 71.1286 506.961 71.7251C505.41 72.3118 503.655 72.6051 501.696 72.6051C498.972 72.6051 496.536 71.9886 494.388 70.7557C492.25 69.5227 490.56 67.7379 489.317 65.4013C488.084 63.0646 487.468 60.2358 487.468 56.9148C487.468 53.5838 488.094 50.75 489.347 48.4134C490.6 46.0767 492.3 44.2969 494.448 43.0739C496.595 41.8409 499.012 41.2244 501.696 41.2244C503.466 41.2244 505.107 41.473 506.618 41.9702C508.139 42.4673 509.487 43.1932 510.66 44.1477C511.833 45.0923 512.788 46.2507 513.524 47.6229C514.269 48.995 514.747 50.5661 514.955 52.3359ZM524.277 72.1875H517.357L527.901 41.642H536.224L546.754 72.1875H539.833L532.182 48.6222H531.943L524.277 72.1875ZM523.845 60.1811H540.191V65.2223H523.845V60.1811ZM550.43 72.1875V41.642H556.888V66.8629H569.983V72.1875H550.43ZM583.981 72.1875V41.642H604.205V46.9666H590.439V54.245H602.863V59.5696H590.439V72.1875H583.981ZM608.549 72.1875V41.642H620.6C622.907 41.642 624.876 42.0547 626.507 42.88C628.147 43.6953 629.395 44.8537 630.25 46.3551C631.115 47.8466 631.548 49.6016 631.548 51.62C631.548 53.6484 631.11 55.3935 630.235 56.8551C629.36 58.3068 628.093 59.4205 626.432 60.196C624.782 60.9716 622.783 61.3594 620.436 61.3594H612.368V56.169H619.392C620.625 56.169 621.65 56 622.465 55.6619C623.28 55.3239 623.887 54.8168 624.284 54.1406C624.692 53.4645 624.896 52.6243 624.896 51.62C624.896 50.6058 624.692 49.7507 624.284 49.0547C623.887 48.3587 623.275 47.8317 622.45 47.4737C621.635 47.1058 620.605 46.9219 619.363 46.9219H615.007V72.1875H608.549ZM625.045 58.2869L632.637 72.1875H625.507L618.08 58.2869H625.045ZM636.112 72.1875V41.642H656.694V46.9666H642.57V54.245H655.635V59.5696H642.57V66.8629H656.754V72.1875H636.112ZM678.399 50.4268C678.28 49.2237 677.768 48.2891 676.863 47.6229C675.958 46.9567 674.73 46.6236 673.179 46.6236C672.125 46.6236 671.235 46.7727 670.509 47.071C669.783 47.3594 669.226 47.7621 668.839 48.2791C668.461 48.7962 668.272 49.3828 668.272 50.0391C668.252 50.5859 668.366 51.0632 668.615 51.4709C668.873 51.8786 669.226 52.2315 669.674 52.5298C670.121 52.8182 670.638 53.0717 671.225 53.2905C671.812 53.4993 672.438 53.6783 673.104 53.8274L675.849 54.4837C677.181 54.782 678.404 55.1797 679.518 55.6768C680.631 56.174 681.596 56.7855 682.411 57.5114C683.226 58.2372 683.858 59.0923 684.305 60.0767C684.763 61.0611 684.996 62.1896 685.006 63.4624C684.996 65.3317 684.519 66.9524 683.574 68.3246C682.64 69.6868 681.287 70.7457 679.518 71.5014C677.758 72.2472 675.635 72.62 673.149 72.62C670.683 72.62 668.535 72.2422 666.706 71.4865C664.886 70.7308 663.464 69.6122 662.44 68.1307C661.426 66.6392 660.894 64.7947 660.844 62.5973H667.094C667.163 63.6214 667.456 64.4766 667.974 65.1626C668.501 65.8388 669.202 66.3509 670.077 66.6989C670.961 67.0369 671.961 67.206 673.074 67.206C674.168 67.206 675.118 67.0469 675.923 66.7287C676.738 66.4105 677.37 65.968 677.817 65.4013C678.265 64.8345 678.488 64.1832 678.488 63.4474C678.488 62.7614 678.285 62.1847 677.877 61.7173C677.479 61.25 676.893 60.8523 676.117 60.5241C675.351 60.196 674.412 59.8977 673.298 59.6293L669.972 58.794C667.397 58.1676 665.363 57.1882 663.872 55.8558C662.381 54.5234 661.64 52.7287 661.65 50.4716C661.64 48.6222 662.132 47.0064 663.126 45.6243C664.131 44.2422 665.508 43.1634 667.258 42.3878C669.008 41.6122 670.996 41.2244 673.224 41.2244C675.491 41.2244 677.469 41.6122 679.16 42.3878C680.86 43.1634 682.182 44.2422 683.127 45.6243C684.072 47.0064 684.559 48.6072 684.589 50.4268H678.399ZM689.35 72.1875V41.642H695.808V54.245H708.918V41.642H715.362V72.1875H708.918V59.5696H695.808V72.1875H689.35ZM736.865 41.642V72.1875H730.407V41.642H736.865ZM767.727 41.642V72.1875H762.149L748.86 52.9624H748.636V72.1875H742.178V41.642H747.846L761.031 60.8523H761.299V41.642H767.727ZM793.317 51.5156C793.108 50.7898 792.815 50.1484 792.437 49.5916C792.059 49.0249 791.597 48.5476 791.05 48.1598C790.513 47.7621 789.897 47.4588 789.201 47.25C788.515 47.0412 787.754 46.9368 786.919 46.9368C785.358 46.9368 783.986 47.3246 782.802 48.1001C781.629 48.8757 780.714 50.0043 780.058 51.4858C779.402 52.9574 779.074 54.7571 779.074 56.8849C779.074 59.0128 779.397 60.8224 780.043 62.3139C780.689 63.8054 781.604 64.9439 782.787 65.7294C783.971 66.505 785.368 66.8928 786.979 66.8928C788.44 66.8928 789.688 66.6342 790.722 66.1172C791.766 65.5902 792.562 64.8494 793.108 63.8949C793.665 62.9403 793.944 61.8118 793.944 60.5092L795.256 60.7031H787.381V55.8409H800.163V59.6889C800.163 62.3736 799.596 64.6804 798.463 66.6094C797.329 68.5284 795.768 70.0099 793.78 71.054C791.791 72.0881 789.514 72.6051 786.949 72.6051C784.085 72.6051 781.569 71.9737 779.402 70.7109C777.234 69.4382 775.544 67.6335 774.331 65.2969C773.128 62.9503 772.526 60.1662 772.526 56.9446C772.526 54.4687 772.884 52.2614 773.6 50.3224C774.326 48.3736 775.34 46.723 776.643 45.3707C777.945 44.0185 779.461 42.9893 781.192 42.2834C782.922 41.5774 784.796 41.2244 786.814 41.2244C788.545 41.2244 790.155 41.478 791.647 41.9851C793.138 42.4822 794.461 43.1882 795.614 44.103C796.778 45.0178 797.727 46.1065 798.463 47.3693C799.199 48.6222 799.671 50.0043 799.88 51.5156H793.317ZM805.014 72.1875V41.642H817.065C819.372 41.642 821.341 42.0547 822.972 42.88C824.612 43.6953 825.86 44.8537 826.715 46.3551C827.58 47.8466 828.013 49.6016 828.013 51.62C828.013 53.6484 827.575 55.3935 826.7 56.8551C825.825 58.3068 824.558 59.4205 822.897 60.196C821.246 60.9716 819.248 61.3594 816.901 61.3594H808.832V56.169H815.857C817.09 56.169 818.114 56 818.93 55.6619C819.745 55.3239 820.352 54.8168 820.749 54.1406C821.157 53.4645 821.361 52.6243 821.361 51.62C821.361 50.6058 821.157 49.7507 820.749 49.0547C820.352 48.3587 819.74 47.8317 818.915 47.4737C818.099 47.1058 817.07 46.9219 815.827 46.9219H811.472V72.1875H805.014ZM821.51 58.2869L829.102 72.1875H821.972L814.545 58.2869H821.51ZM832.577 72.1875V41.642H853.159V46.9666H839.035V54.245H852.1V59.5696H839.035V66.8629H853.219V72.1875H832.577ZM869.122 72.1875H858.294V41.642H869.211C872.284 41.642 874.928 42.2536 877.146 43.4766C879.363 44.6896 881.068 46.4347 882.262 48.7116C883.465 50.9886 884.066 53.7131 884.066 56.8849C884.066 60.0668 883.465 62.8011 882.262 65.0881C881.068 67.375 879.353 69.13 877.116 70.353C874.889 71.576 872.224 72.1875 869.122 72.1875ZM864.752 66.6541H868.853C870.762 66.6541 872.368 66.3161 873.671 65.6399C874.983 64.9538 875.968 63.8949 876.624 62.4631C877.29 61.0213 877.623 59.1619 877.623 56.8849C877.623 54.6278 877.29 52.7834 876.624 51.3516C875.968 49.9197 874.988 48.8658 873.686 48.1896C872.383 47.5135 870.777 47.1754 868.868 47.1754H864.752V66.6541ZM895.308 41.642V72.1875H888.85V41.642H895.308ZM900.622 72.1875V41.642H921.204V46.9666H907.08V54.245H920.145V59.5696H907.08V66.8629H921.264V72.1875H900.622ZM951.887 41.642V72.1875H946.309L933.02 52.9624H932.797V72.1875H926.338V41.642H932.006L945.191 60.8523H945.459V41.642H951.887ZM956.06 46.9666V41.642H981.146V46.9666H971.795V72.1875H965.411V46.9666H956.06ZM1001.85 50.4268C1001.73 49.2237 1001.22 48.2891 1000.31 47.6229C999.407 46.9567 998.179 46.6236 996.628 46.6236C995.574 46.6236 994.684 46.7727 993.958 47.071C993.232 47.3594 992.676 47.7621 992.288 48.2791C991.91 48.7962 991.721 49.3828 991.721 50.0391C991.701 50.5859 991.816 51.0632 992.064 51.4709C992.323 51.8786 992.676 52.2315 993.123 52.5298C993.57 52.8182 994.088 53.0717 994.674 53.2905C995.261 53.4993 995.887 53.6783 996.553 53.8274L999.298 54.4837C1000.63 54.782 1001.85 55.1797 1002.97 55.6768C1004.08 56.174 1005.04 56.7855 1005.86 57.5114C1006.68 58.2372 1007.31 59.0923 1007.75 60.0767C1008.21 61.0611 1008.45 62.1896 1008.46 63.4624C1008.45 65.3317 1007.97 66.9524 1007.02 68.3246C1006.09 69.6868 1004.74 70.7457 1002.97 71.5014C1001.21 72.2472 999.084 72.62 996.598 72.62C994.132 72.62 991.985 72.2422 990.155 71.4865C988.335 70.7308 986.914 69.6122 985.889 68.1307C984.875 66.6392 984.343 64.7947 984.294 62.5973H990.543C990.612 63.6214 990.906 64.4766 991.423 65.1626C991.95 65.8388 992.651 66.3509 993.526 66.6989C994.411 67.0369 995.41 67.206 996.524 67.206C997.617 67.206 998.567 67.0469 999.372 66.7287C1000.19 66.4105 1000.82 65.968 1001.27 65.4013C1001.71 64.8345 1001.94 64.1832 1001.94 63.4474C1001.94 62.7614 1001.73 62.1847 1001.33 61.7173C1000.93 61.25 1000.34 60.8523 999.566 60.5241C998.801 60.196 997.861 59.8977 996.747 59.6293L993.421 58.794C990.846 58.1676 988.813 57.1882 987.321 55.8558C985.83 54.5234 985.089 52.7287 985.099 50.4716C985.089 48.6222 985.581 47.0064 986.575 45.6243C987.58 44.2422 988.957 43.1634 990.707 42.3878C992.457 41.6122 994.445 41.2244 996.673 41.2244C998.94 41.2244 1000.92 41.6122 1002.61 42.3878C1004.31 43.1634 1005.63 44.2422 1006.58 45.6243C1007.52 47.0064 1008.01 48.6072 1008.04 50.4268H1001.85Z",
    fill: "#E5BAB4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2701_497)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2701_497)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 266.188V86.1875H70V266.188H45ZM67 162.188H57.5H48C48 157.631 51.8161 150.188 57.5 150.188C63.1839 150.188 67 157.631 67 162.188ZM48.0001 164.188L57.5001 196.188L67.0001 164.188H48.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 266.188,
    x2: 111.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.5,
    y1: 266.188,
    x2: 155.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202 266.188V86.1875H227V266.188H202ZM224 162.188H214.5H205C205 157.631 208.816 150.188 214.5 150.188C220.184 150.188 224 157.631 224 162.188ZM205 164.188L214.5 196.188L224 164.188H205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.5,
    y1: 266.188,
    x2: 268.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.5,
    y1: 266.188,
    x2: 312.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359 266.188V86.1875H384V266.188H359ZM381 162.188H371.5H362C362 157.631 365.816 150.188 371.5 150.188C377.184 150.188 381 157.631 381 162.188ZM362 164.188L371.5 196.188L381 164.188H362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.5,
    y1: 266.188,
    x2: 425.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469.5,
    y1: 266.188,
    x2: 469.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516 266.188V86.1875H541V266.188H516ZM538 162.188H528.5H519C519 157.631 522.816 150.188 528.5 150.188C534.184 150.188 538 157.631 538 162.188ZM519 164.188L528.5 196.188L538 164.188H519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.5,
    y1: 266.188,
    x2: 582.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 626.5,
    y1: 266.188,
    x2: 626.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673 266.188V86.1875H698V266.188H673ZM695 162.188H685.5H676C676 157.631 679.816 150.188 685.5 150.188C691.184 150.188 695 157.631 695 162.188ZM676 164.188L685.5 196.188L695 164.188H676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M742 266.188V86.1875H767V266.188H742ZM764 162.188H754.5H745C745 157.631 748.816 150.188 754.5 150.188C760.184 150.188 764 157.631 764 162.188ZM745 164.188L754.5 196.188L764 164.188H745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 808.5,
    y1: 266.188,
    x2: 808.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 852.5,
    y1: 266.188,
    x2: 852.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899 266.188V86.1875H924V266.188H899ZM921 162.188H911.5H902C902 157.631 905.816 150.188 911.5 150.188C917.184 150.188 921 157.631 921 162.188ZM902 164.188L911.5 196.188L921 164.188H902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 965.5,
    y1: 266.188,
    x2: 965.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1009.5,
    y1: 266.188,
    x2: 1009.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1056 266.188V86.1875H1081V266.188H1056ZM1078 162.188H1068.5H1059C1059 157.631 1062.82 150.188 1068.5 150.188C1074.18 150.188 1078 157.631 1078 162.188ZM1059 164.188L1068.5 196.188L1078 164.188H1059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1122.5,
    y1: 266.188,
    x2: 1122.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1166.5,
    y1: 266.188,
    x2: 1166.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1213 266.188V86.1875H1238V266.188H1213ZM1235 162.188H1225.5H1216C1216 157.631 1219.82 150.188 1225.5 150.188C1231.18 150.188 1235 157.631 1235 162.188ZM1216 164.188L1225.5 196.188L1235 164.188H1216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1279.5,
    y1: 266.188,
    x2: 1279.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1323.5,
    y1: 266.188,
    x2: 1323.5,
    y2: 86.1875,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1370 266.188V86.1875H1395V266.188H1370ZM1392 162.188H1382.5H1373C1373 157.631 1376.82 150.188 1382.5 150.188C1388.18 150.188 1392 157.631 1392 162.188ZM1373 164.188L1382.5 196.188L1392 164.188H1373Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 88.1875,
    width: 1436,
    height: 24,
    stroke: "white",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2701_497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 28,
    fill: "white",
    transform: "translate(0 0.1875)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2701_497"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.1875,
    width: 1440,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2701_497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 28,
    fill: "white",
    transform: "translate(0 86.1875)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2701_497"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 86.1875,
    width: 1440,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkWood);
export default __webpack_public_path__ + "static/media/pinkWood.273bf05fedccde3a740deb550faa66b5.svg";
export { ForwardRef as ReactComponent };